import axios from 'axios'
import AuthToken from '@/auth/auth-token'


class Items {
  constructor() {
    const base = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json'
      }
    })
    this.tprs = base
  }

  async getItems(batch_id, itemSearchVM, limit = 100, offset = 0) {
    await AuthToken.setAuth(this.tprs)
    const params = {
      limit: limit,
      offset: offset
    }
    return this.tprs({
      url: `/tpr/tpr_search/${batch_id}`,  
      method: 'POST',
      data: itemSearchVM, 
      params: params
    })
  }

  async getChangedItems(batch_id) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: `/tpr/tpr_changed_items/${batch_id}`,  
      method: 'POST'
    })
  }


  async getComponents(batch_id, shipper_item_id, limit=100, offset=0) {
      await AuthToken.setAuth(this.tprs)
      return this.tprs({
        url: `/tpr/tpr_component/${batch_id}`,  
        method: 'GET',
        params: {
          shipper_item_id: shipper_item_id,
          limit: limit,
          offset: offset
        }  
      })
  }

  async getUniqueValues(batch_id, column) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: `/tpr/unique_batch_values/${batch_id}`,
      method: 'POST',
      params: {
        column: column 
      }
    })
  }

  async getPromosByRow(batchId, tprId) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: '/tpr/rolled_promos',
      method: 'GET',
      params: {
        batch_id: batchId,
        tpr_mgmt_id: tprId,
        limit: 100,
        offset: 0
      }
    })
  }

  async getPromoPromotionPrice(batchId, itemId, promotionCategory) {
    await AuthToken.setAuth(this.tprs)
    const params = {
      batch_id: batchId,
      item_id: itemId,
      promotion_category: promotionCategory
    }
    return this.tprs({
      url: '/tpr/promo_promotion_price',
      method: 'GET',
      params: params
    })
  }

  async tprUpdate(requestBody) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: '/tpr/tpr_report/update',
      method: 'PUT',
      data: requestBody
    })
  }

  async tprDelete(tprId) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: `/tpr/tpr_report/${tprId}`,
      method: 'DELETE',
    })
  }

  async updateExcludeInclude(id, excluded) {
    await AuthToken.setAuth(this.tprs)
    return this.tprs({
      url: '/tpr/tpr_report/exclude_include',
      method: 'PUT',
      data: {
        id: id,
        excluded: excluded
      }
    })
  }

  async updateExcludeIncludeBulk(excludeIncludes) {
    await AuthToken.setAuth(this.tprs);
    return this.tprs({
      url: '/tpr/tpr_report/bulk_exclude_include',
      method: 'PUT',
      data: excludeIncludes  
    });
 }

 async triggerExport20(adGroupId, adGroupName) {
  await AuthToken.setAuth(this.tprs)
  return this.tprs({
    url: '/tpr/trigger_export_20', 
    method: 'POST',
    params: {
      ad_group_id: adGroupId,
      ad_group_name: adGroupName
    }
  });
}

async getExport20Status(adGroupId, limit = 50, offset = 0) {
  await AuthToken.setAuth(this.tprs)
  return this.tprs({
    url: '/tpr/export_20_status',
    method: 'GET',
    params: {
      limit: limit,
      offset: offset
    }
  })
}

}

export default new Items()
